import React from 'react';
import { VipAndLatestAdsSkeletonLoader } from './VipAndLatestAdsSkeletonLoader';
import { useCurrentCategory } from '@/hooks/useCurrentCategory/useCurrentCategory';
import { VipAndLatestAdsWithInfiniteScroll } from '@/components/AdsWithInfiniteScroll/VipAndLatestAdsWithInfiniteScroll';

export const VipAndLatestAds = () => {
  const { currentCategory } = useCurrentCategory();

  if (!currentCategory?.id) {
    return <VipAndLatestAdsSkeletonLoader />;
  }

  return <VipAndLatestAdsWithInfiniteScroll />;
};
